import {useRef, useState} from 'react'
import XP from '../../assets/imagens/icone_XP.png'

import { AiOutlineMenu } from "react-icons/ai";
import { RiMenu2Fill } from "react-icons/ri";

import './Header.css'
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { color } from 'motion';
import Menu from '../Menu';
export default function Header(){
    const xpRef = useRef(null)
    const {user, score} = useAuth()
    const navigate = useNavigate()
    const [menuOpen, setMenuOpen]= useState(false)

    return(
        <>
            <header className="header">
                <div className='containerHeader'>


                    <div>
                        <button onClick={()=>setMenuOpen(!menuOpen)} className='btnMenu'>
                            <AiOutlineMenu color="#fff" size={30}/>
                        </button>

                    </div>


                    <div ref={xpRef} id="xp-box" className="pontuacao">
                        <img src={XP} width={25} height={25}/>
                        <p className="numero">{score}</p>
                    </div>
                </div>
            </header>

            <Menu menuOpen={menuOpen} setMenu={setMenuOpen}/>
        </>
    )
} 